function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function escapeHTML(value) {
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function fieldTemplate(view) {
  var chooseNew = Boolean(view.choose_new);
  var signerReady = view.signer_ready !== false;
  var type = String(view.type || '');
  var allowEveryPage = Boolean(view.allow_every_page);
  var showEveryPage = allowEveryPage && (type === 'signature' || type === 'initial');
  var types = [['', 'What should this user do?'], ['signature', 'Signature'], ['initial', 'Initial'], ['date', 'Date / Time']].filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      value = _ref2[0];
    return value !== '' || !view.existing;
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      value = _ref4[0],
      label = _ref4[1];
    var selected = type === value ? ' selected' : '';
    var disabled = value === '' ? ' disabled' : '';
    return "<option value=\"".concat(value, "\"").concat(selected).concat(disabled, ">").concat(label, "</option>");
  }).join('');
  var signers = view.signers.map(function (signer) {
    var selected = !chooseNew && signer.index === view.signer_index ? ' selected' : '';
    return "<option value=\"".concat(signer.index, "\"").concat(selected, ">").concat(escapeHTML(signer.name), "</option>");
  }).join('');
  var remove = view.existing && view.editable ? '<button type="button" data-remove-field aria-label="Delete"><i class="fa-solid fa-trash" aria-hidden="true"></i></button>' : '';
  var primary = view.can_sign ? 'Sign' : 'Confirm';
  var mode = view.can_sign ? 'sign' : 'confirm';
  var disabled = view.editable ? '' : ' disabled';
  var submit = view.editable || view.can_sign ? "<button type=\"submit\" class=\"primary\" data-mode=\"".concat(mode, "\">").concat(primary, "</button>") : '';
  return "\n    <form class=\"saitosign-field\">\n      <label>\n        Who\n        <select data-field-signer".concat(disabled, ">\n          ").concat(signers, "\n          <option value=\"new\"").concat(chooseNew ? ' selected' : '', ">Add New Signer</option>\n        </select>\n      </label>\n      <div class=\"new-signer\"").concat(chooseNew ? '' : ' hidden', ">\n        <input data-signer-name type=\"text\" placeholder=\"name\" value=\"").concat(escapeHTML(view.new_name || ''), "\" aria-label=\"Signer name\" autocomplete=\"name\" />\n        <input data-signer-email type=\"email\" placeholder=\"email\" value=\"").concat(escapeHTML(view.new_email || ''), "\" aria-label=\"Signer email\" autocomplete=\"email\" />\n      </div>\n      <div class=\"what\"").concat(signerReady ? '' : ' hidden', ">\n        <select data-field-type aria-label=\"What should this user do?\"").concat(disabled, ">").concat(types, "</select>\n        <div class=\"field-details\" data-field-details").concat(showEveryPage ? '' : ' hidden', ">\n          ").concat(allowEveryPage ? "<label class=\"check\">\n            <input type=\"checkbox\" data-every-page".concat(view.every_page ? ' checked' : '').concat(disabled, " />\n            <span>add to every page</span>\n          </label>") : '', "\n        </div>\n      </div>\n      <p class=\"form-error\" data-form-error hidden></p>\n      <div class=\"actions\">\n        ").concat(remove, "\n        ").concat(submit, "\n      </div>\n    </form>\n  ");
}
module.exports = fieldTemplate;